'use es6';

import { getFileMetadata } from 'conversations-internal-schema/resolved-attachment/operators/resolvedAttachmentGetters';
import { List } from 'immutable';
import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import styled from 'styled-components';
import FileAttachmentTile from './FileAttachmentTile';
import { jsx as _jsx } from "react/jsx-runtime";
export const FileAttachmentsFooterWrapper = styled.div.attrs({
  'data-test-id': 'file-attachments-footer'
}).withConfig({
  displayName: "FileAttachmentsFooter__FileAttachmentsFooterWrapper",
  componentId: "sc-1he1r23-0"
})(["cursor:pointer;box-sizing:border-box;display:block;"]);
class FileAttachmentsFooter extends PureComponent {
  render() {
    const {
      fileAttachments,
      genericChannelId
    } = this.props;
    return /*#__PURE__*/_jsx(FileAttachmentsFooterWrapper, {
      children: fileAttachments.map((fileAttachment, index) => {
        const fileMetadata = getFileMetadata(fileAttachment);
        return fileMetadata && /*#__PURE__*/_jsx(FileAttachmentTile, {
          fileMetadata: fileMetadata,
          genericChannelId: genericChannelId
        }, index);
      })
    });
  }
}
FileAttachmentsFooter.displayName = 'FileAttachmentsFooter';
FileAttachmentsFooter.propTypes = {
  fileAttachments: PropTypes.instanceOf(List),
  genericChannelId: PropTypes.number.isRequired
};
export default FileAttachmentsFooter;